export const sortIgnoreCase = (a, b) => a.toLowerCase().localeCompare(b.toLowerCase())

export const socksConnString = (user, pwd, host, port) => user + ":" + pwd + "@" + host + ":" + port

export const openTermsAndConditions = () => window.open("https://bigmama.network/terms_conditions.html", "_blank")
